import styled from "styled-components";

export const SlideImage = styled.img`
  width: 100vw;
  height: 800px;
  object-fit: cover;
`;

export const StyledSlider = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;